import http from '@/http/aisea/axios'
const resource = "/enterprises/manning/vessels";

export default {

  search(payload) {
    return http.get(`${resource}`, {
      params: payload
    });
  },

  // fetch(id) {
  //   return http.get(`${resource}/${id}`);
  // },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  update(id, payload) {
    return http.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return http.delete(`${resource}/${id}`);
  },
};
